import axios, { AxiosInstance } from "axios";
import { attachMicrosoftEntraBearer } from "./attachMicrosoftEntraBearer";
import {
  getStoredAccessToken,
  isAccessTokenExpired,
  isAuthEnabled,
  isUnauthorizedHttpStatus,
  redirectToLogin,
} from "./authSession";

axios.defaults.withCredentials = true;

export const kbAxiosInstance: AxiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_KB_API_ENDPOINT || 'https://searchknowledgebase.talentica.com/api',
  headers: {
    "Content-type": "application/json",
  },
});

function rejectIfSessionExpired(): Error | null {
  if (!isAuthEnabled()) {
    return null;
  }
  const token = getStoredAccessToken();
  if (token && isAccessTokenExpired(token)) {
    redirectToLogin();
    return new Error("Session expired");
  }
  return null;
}

// Request interceptor - add auth token
kbAxiosInstance.interceptors.request.use(
  (config) => {
    const sessionError = rejectIfSessionExpired();
    if (sessionError) {
      return Promise.reject(sessionError);
    }
    attachMicrosoftEntraBearer(config);
    // Remove Content-Type header for FormData - browser will set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers["Content-type"];
      delete config.headers["Content-Type"];
      // Ensure axios doesn't serialize FormData
      config.transformRequest = [(data) => data];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
kbAxiosInstance.interceptors.response.use(
  (res) => {
    if (isUnauthorizedHttpStatus(res.status)) {
      redirectToLogin();
    }
    return res;
  },
  (err) => {
    if (isUnauthorizedHttpStatus(err.response?.status)) {
      redirectToLogin();
    }
    return Promise.reject(err);
  }
);
